const vP18289 = require("./121.js");
const vP182892 = require("./369.js");
const vP182893 = require("./370.js");
const vP182894 = require("./371.js");
const vP182895 = require("./373.js");
const vP182896 = require("./305.js");
const vP182897 = require("./120.js");
const vP182898 = require("./374.js");
function f2177(p18290) {
  return unescape(encodeURIComponent(p18290)).length;
}
function f2178(p18291, p18292, p18293) {
  const vA789 = [];
  for (let v14057; (v14057 = p18291.exec(p18293)) !== null;) {
    vA789.push({
      data: v14057[0],
      index: v14057.index,
      mode: p18292,
      length: v14057[0].length
    });
  }
  return vA789;
}
function f2179(p18294) {
  const vF2178 = f2178(vP182896.NUMERIC, vP18289.NUMERIC, p18294);
  const vF21782 = f2178(vP182896.ALPHANUMERIC, vP18289.ALPHANUMERIC, p18294);
  let v14058;
  let v14059;
  if (vP182897.isKanjiModeEnabled()) {
    v14058 = f2178(vP182896.BYTE, vP18289.BYTE, p18294);
    v14059 = f2178(vP182896.KANJI, vP18289.KANJI, p18294);
  } else {
    v14058 = f2178(vP182896.BYTE_KANJI, vP18289.BYTE, p18294);
    v14059 = [];
  }
  const v14060 = vF2178.concat(vF21782, v14058, v14059);
  return v14060.sort(function (p18295, p18296) {
    return p18295.index - p18296.index;
  }).map(function (p18297) {
    return {
      data: p18297.data,
      mode: p18297.mode,
      length: p18297.length
    };
  });
}
function f2180(p18298, p18299) {
  if (p18299 === vP18289.NUMERIC) {
    return vP182892.getBitsLength(p18298);
  } else if (p18299 === vP18289.ALPHANUMERIC) {
    return vP182893.getBitsLength(p18298);
  } else if (p18299 === vP18289.KANJI) {
    return vP182895.getBitsLength(p18298);
  } else if (p18299 === vP18289.BYTE) {
    return vP182894.getBitsLength(p18298);
  } else {
    return undefined;
  }
}
function f2181(p18300) {
  return p18300.reduce(function (p18301, p18302) {
    const v14061 = p18301.length - 1 >= 0 ? p18301[p18301.length - 1] : null;
    if (v14061 && v14061.mode === p18302.mode) {
      p18301[p18301.length - 1].data += p18302.data;
      return p18301;
    } else {
      p18301.push(p18302);
      return p18301;
    }
  }, []);
}
function f2182(p18303) {
  const vA790 = [];
  for (let vLN02592 = 0; vLN02592 < p18303.length; vLN02592++) {
    const v14062 = p18303[vLN02592];
    switch (v14062.mode) {
      case vP18289.NUMERIC:
        vA790.push([v14062, {
          data: v14062.data,
          mode: vP18289.ALPHANUMERIC,
          length: v14062.length
        }, {
          data: v14062.data,
          mode: vP18289.BYTE,
          length: v14062.length
        }]);
        break;
      case vP18289.ALPHANUMERIC:
        vA790.push([v14062, {
          data: v14062.data,
          mode: vP18289.BYTE,
          length: v14062.length
        }]);
        break;
      case vP18289.KANJI:
        vA790.push([v14062, {
          data: v14062.data,
          mode: vP18289.BYTE,
          length: f2177(v14062.data)
        }]);
        break;
      case vP18289.BYTE:
        vA790.push([{
          data: v14062.data,
          mode: vP18289.BYTE,
          length: f2177(v14062.data)
        }]);
    }
  }
  return vA790;
}
function f2183(p18304, p18305) {
  const vO472 = {};
  const vO473 = {
    start: {}
  };
  let vA791 = ["start"];
  for (let vLN02593 = 0; vLN02593 < p18304.length; vLN02593++) {
    const v14063 = p18304[vLN02593];
    const vA792 = [];
    for (let vLN02594 = 0; vLN02594 < v14063.length; vLN02594++) {
      const v14064 = v14063[vLN02594];
      const v14065 = "" + vLN02593 + vLN02594;
      vA792.push(v14065);
      vO472[v14065] = {
        node: v14064,
        lastCount: 0
      };
      vO473[v14065] = {};
      for (let vLN02595 = 0; vLN02595 < vA791.length; vLN02595++) {
        const v14066 = vA791[vLN02595];
        if (vO472[v14066] && vO472[v14066].node.mode === v14064.mode) {
          vO473[v14066][v14065] = f2180(vO472[v14066].lastCount + v14064.length, v14064.mode) - f2180(vO472[v14066].lastCount, v14064.mode);
          vO472[v14066].lastCount += v14064.length;
        } else {
          if (vO472[v14066]) {
            vO472[v14066].lastCount = v14064.length;
          }
          vO473[v14066][v14065] = f2180(v14064.length, v14064.mode) + 4 + vP18289.getCharCountIndicator(v14064.mode, p18305);
        }
      }
    }
    vA791 = vA792;
  }
  for (let vLN02596 = 0; vLN02596 < vA791.length; vLN02596++) {
    vO473[vA791[vLN02596]].end = 0;
  }
  return {
    map: vO473,
    table: vO472
  };
}
function f2184(p18306, p18307) {
  let v14067;
  const v14068 = vP18289.getBestModeForData(p18306);
  v14067 = vP18289.from(p18307, v14068);
  if (v14067 !== vP18289.BYTE && v14067.bit < v14068.bit) {
    throw new Error("\"" + p18306 + "\" cannot be encoded with mode " + vP18289.toString(v14067) + ".\n Suggested mode is: " + vP18289.toString(v14068));
  }
  if (v14067 === vP18289.KANJI && !vP182897.isKanjiModeEnabled()) {
    v14067 = vP18289.BYTE;
  }
  if (v14067 === vP18289.NUMERIC) {
    return new vP182892(p18306);
  } else if (v14067 === vP18289.ALPHANUMERIC) {
    return new vP182893(p18306);
  } else if (v14067 === vP18289.KANJI) {
    return new vP182895(p18306);
  } else if (v14067 === vP18289.BYTE) {
    return new vP182894(p18306);
  } else {
    return undefined;
  }
}
exports.fromArray = function (p18308) {
  return p18308.reduce(function (p18309, p18310) {
    if (typeof p18310 == "string") {
      p18309.push(f2184(p18310, null));
    } else if (p18310.data) {
      p18309.push(f2184(p18310.data, p18310.mode));
    }
    return p18309;
  }, []);
};
exports.fromString = function (p18311, p18312) {
  const vF2179 = f2179(p18311, vP182897.isKanjiModeEnabled());
  const vF2182 = f2182(vF2179);
  const vF2183 = f2183(vF2182, p18312);
  const v14069 = vP182898.find_path(vF2183.map, "start", "end");
  const vA793 = [];
  for (let vLN1177 = 1; vLN1177 < v14069.length - 1; vLN1177++) {
    vA793.push(vF2183.table[v14069[vLN1177]].node);
  }
  return exports.fromArray(f2181(vA793));
};
exports.rawSplit = function (p18313) {
  return exports.fromArray(f2179(p18313, vP182897.isKanjiModeEnabled()));
};